import React, { useState, useRef, useEffect } from 'react';
import useCheckupCardStore from '../../_store/useCheckupCardStore';
import TooltipBox from '../Tooltip/TooltipBox';
import './TabProduct.scss';

const TabProduct = () => {
    const wrapperRef = useRef(null);
    const [activeTab, setActiveTab] = useState(0);
    const { checkupCardItems, setCardDisable } = useCheckupCardStore();
    const tabTitles = ["All", "Light", "Wave", "Bounce", "Premium"];

    useEffect(() => {
        window.addEventListener('click', handleOutsideClick);
        return () => window.removeEventListener('click', handleOutsideClick);
    }, []);

    const tabBtnClick = (idx, tabName) => {
        setActiveTab(idx);
        setCardDisable(tabName);
    };

    const handleOutsideClick = (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        }
    };

    const setBadgeComponent = (imgClassName) => {
        if(imgClassName === "pms") {
            return (
                <>
                    <div className="tag-area pms">
                        <span>여성검사</span>
                    </div>
                </>
            );
        } else if (imgClassName === "prostate") {
            return (
                <>
                    <div className="tag-area prostate">
                        <span>남성검사</span>
                    </div>
                </>
            );
        } else {
            return (<></>);
        }
    }
    
    return (
        <div>
            {/* 탭메뉴 - PC */}
            <div className="product-tab-menu">
                <ul className="product-tab-menu-list">
                    {tabTitles.map((item, idx) => {
                        return (
                            <li key={idx}
                                className={activeTab === idx ? 'active' : ''}
                            >
                                <button onClick={() => tabBtnClick(idx, item)}>
                                    {item}
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>

            {/* 아이템 목록 - PC */}
            <div className="item-list-container">
                <ul className="item-list">
                    { checkupCardItems.map((item, idx) => (
                        <li 
                            key={idx}
                            className={item.isEnable ? '' : 'disabled'}
                        >
                            <div className="title-area">
                                <span className={`ico ${item.imgClassName}`}></span>
                                <strong>
                                    {item.cardName.split('<br/>').map((line, idx) => (
                                        <React.Fragment key={idx}>
                                            {line}
                                        </React.Fragment>
                                    ))} 검사
                                </strong>
                            </div>

                            <div className="desc-area">
                                <span>{item.desc}</span>
                            </div>

                            {setBadgeComponent(item.imgClassName)}

                            {item.imgClassName === 'cgm' || item.imgClassName === 'cardiogram' ? (
                                <>
                                    <TooltipBox 
                                        index={0}
                                        containerClass="mw380"
                                        className = {item.imgClassName} >
                                    </TooltipBox>
                                </>
                            ) : (
                                <></>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default TabProduct;
